import { fortLeeConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function FortLeePage() {
  return <CityPageTemplate config={fortLeeConfig} />;
}